import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { motion } from "framer-motion";
import { useBreakpoints } from "./ResponsiveBreapoints";

const HeroSection = () => {
  const { IsXS, IsSM } = useBreakpoints();
  const card = [
    {
      title: "ACCESS OUR INVESTOR NETWORK",
      heading:
        "Tap into a global network of investors ready to support your vision",
      color: "#2a75bb",
      paragraph: [
        {
          title: "Investor Conferences",
          heading: "Connect Directly with Qualified Investors",
          value: "investor",
          description: [
            "Access Exclusive Investor Groups: Pre-qualified institutional investors, family offices, and HNWIs.",
            "Targeted Small/Mid-Cap Focus: Connect with investors actively seeking opportunities in your market segment.",
            "Foster Meaningful Relationships: Intimate setting (80-100 attendees) ideal for networking and deal-making.",
            "Maximize Your Exposure: Multiple events over two days possible, with unique investor sets at each.",
            "Prime Locations: Conveniently located in South Florida and New York City.",
          ],
        },
        {
          title: "Newsletters",
          heading: "Keep Investors Informed and Engaged",
          value: "newsletters",
          description: [
            "Targeted Investor Communication: Deliver key updates directly to the right audience.",
            "Showcase Your Success: Share company news and achievements to build investor confidence.",
            "Provide Market Insights: Offer valuable perspectives to position yourself as a thought leader.",
            "Drive Investor Engagement: Increase traffic and interest in your investor relations materials.",
            "Track & Measure Results: Monitor key metrics to optimize newsletter performance.",
            "Enhance Your Professional Image: Maintain consistent, polished communication with investors.",
          ],
        },
      ],
    },
    {
      title: "AMPLIFY YOUR INVESTMENT STORY",
      heading: "Enhance your visibility and attract the right investors",
      color: "#488e35",
      paragraph: [
        {
          title: "Strategic Communications",
          heading: "Reach and Engage Your Target Investors Online",
          value: "strategic",
          description: [
            "Targeted Digital Campaigns: Precision-reach investors across multiple platforms.",
            "Expert Campaign Management: We handle everything from strategy to execution.",
            "Enhance Brand Visibility:  Raise your profile within the investment community.",
            "Strategic Digital Approach: Leverage data-driven insights for optimal results.",
            "Comprehensive Support: Get full-service digital marketing expertise for your IR needs.",
          ],
        },
        {
          title: "Video Creation",
          heading: "Captivate Investors with Compelling Video Content",
          value: "video",
          description: [
            "Craft Engaging Narratives: Tell your story and connect with investors on an emotional level.",
            "Investor Videos: High-quality productions tailored for a financial audience.",
            "AI-Powered Production: Leverage cutting-edge technology for superior results.",
            "Optimized for Financial Networks: Maximize reach and impact on key platforms.",
            "Expert Video Production Team: Benefit from our experienced professionals.",
          ],
        },
        {
          title: "TV Broadcasts",
          heading:
            "Reach a Wider Investor Audience Through Targeted TV Advertising",
          value: "tv",
          description: [
            "Primetime Financial Network Placement: Secure premium advertising slots for maximum visibility.",
            "Amplify Your Message: Broaden your reach and increase investor awareness.",
            "Drive Investor Interest: Generate website traffic and qualified leads.",
            "Build Credibility & Trust: Enhance your reputation through media appearances.",
            "Expert Campaign Management: We handle all aspects of your TV advertising strategy.",
          ],
        },
      ],
    },
    {
      title: "MASTER INVESTOR RELATIONS",
      heading:
        "Expert guidance to build strong investor relationships and achieve your goals",
      color: "#905722",
      paragraph: [
        {
          title: "Investor Relations Consulting",
          heading: "Elevate Your IR Strategy with Expert Guidance",
          value: "relations",
          description: [
            "Strategic IR Guidance: Develop a comprehensive and effective investor relations strategy.",
            "Navigate Capital Markets: Expert advice to help you succeed in the complex world of finance.",
            "Seamless Pre-IPO Planning: Prepare for a successful IPO with our expert guidance.",
            "Access to Expert Network: Connect with top legal, financial, and strategic advisors.",
            "Secure Diverse Funding: Explore and secure a range of funding options.",
            "Tailored IR Strategies: Customized solutions to meet your specific needs and goals.",
            "Ongoing Support & Counsel: Benefit from continuous expert support and advice.",
          ],
        },
        {
          title: "Pre-IPO Consulting",
          heading: "Prepare for a Successful IPO with Confidence",
          value: "ipo",
          description: [
            "Comprehensive IPO Strategies: Develop a robust plan to achieve your IPO objectives.",
            "Public Market Readiness: Ensure your company is fully prepared for the demands of public listing.",
            "Regulatory Compliance Guidance: Navigate complex regulations with expert support.",
            "Best Practices Advisory: Implement investor relations best practices for optimal results.",
            "Attract Top-Tier Investors: Position your company to attract high-quality investors.",
            "Mitigate Risks & Ensure Smooth Execution: Minimize potential risks and streamline the IPO process.",
            "Position for Post-IPO Success: Build a foundation for sustained growth after your IPO.",
          ],
        },
        {
          title: "Expert Introductions",
          heading: "Access a Network of Trusted Partners",
          value: "expert",
          description: [
            "Leading Law Firms: Connect with top legal experts specializing in capital markets transactions.",
            "Top-Tier Investment Banks: Access premier investment banking services for your financing needs.",
            "Experienced Broker-Dealers: Partner with seasoned professionals for effective market access.",
            "Reputable Auditing Firms: Ensure financial compliance with trusted auditing partners.",
            "Specialized Service Providers: Access a network of experts tailored to your specific requirements.",
            "Diverse Funding Options: Explore and secure various funding sources to fuel your growth.",
          ],
        },
      ],
    },
    {
      title: "ENHANCE YOUR ONLINE PRESENCE",
      heading:
        "Expand your reach, engage your audience, and grow your brand online effortlessly.",
      color: "#90225b",
      paragraph: [
        {
          title: "Website Design",
          heading: "Enhance Your Online Presence and Attract Investors",
          value: "website",
          description: [
            "Complete Website Design: A professional website tailored to your brand.",
            "Dedicated IR Section: Showcase key information for investors in a centralized location.",
            "Optimized IR Pages: Improve your existing content for maximum investor engagement.",
            "Targeted Investor Content: Communicate effectively with compelling, investor-specific information.",
            "Engaging & Intuitive Navigation: Make it easy for investors to find the information they need.",
            "User-Friendly Design: Provide a seamless and positive online experience for potential investors.",
          ],
        },
        {
          title: "IR WEBPAGE",
          heading: "Create a Powerful Online Hub for Investors",
          value: "webpage",
          description: [
            "Dedicated IR Webpage Development: Design and build a comprehensive, investor-focused webpage.",
            "Existing IR Page Enhancement: Optimize your current investor relations page for maximum impact.",
            "Compelling Content Creation: Develop engaging content that resonates with investors.",
            "Seamless Integration: Integrate your IR webpage seamlessly with your main website.",
            "User-Friendly Design & Navigation: Ensure a positive and intuitive experience for investors.",
            "Ongoing Maintenance & Support: Keep your IR webpage up-to-date and relevant.",
          ],
        },
      ],
    },
  ];
  return (
    <Grid container justifyContent="center">
      <Grid size={12} className={styles.heroSectionContainer}>
        {card.map((data, index) => {
          return (
            <Grid
              container
              rowSpacing={1}
              key={index}
              pb="80px"
              justifyContent="center"
            >
              <Grid>
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{
                    duration: 1.4,
                    ease: "easeInOut",
                  }}
                  viewport={{ once: true }}
                >
                  <Grid
                    size={12}
                    sx={{ backgroundColor: "#2a75bb", py: "20px", mb: "20px" }}
                  >
                    <Typography
                      className={styles.heroSectionTitle}
                      textAlign="center"
                      color={data.color}
                    >
                      {data.title}
                    </Typography>
                  </Grid>
                  <Grid size={12} >
                    <Grid container justifyContent="center" >
                      <Grid size={{ xs: 11, sm: 11, md: 11, lg: 8, xl: 7, xxl: 5 }}>
                        <Grid container justifyContent='center' rowSpacing={1}>
                          <Grid size={12}>
                            <Grid container justifyContent="center">
                              <Grid
                                size={{ xs: 10, sm: 10, md: 10, lg: 10, xl: 8 }}
                              >
                                <Typography
                                  className={styles.heroSectionHeading}
                                  textAlign="center"
                                  color={data.color}
                                >
                                  {data.heading}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            size={12}
                            pt="20px"
                          >
                            <Grid
                              container
                              columnSpacing={IsSM ? 3 : 7}
                              rowSpacing={5}
                              wrap={IsXS || IsSM ? "" : "nowrap"}
                            >
                              {data.paragraph.map((details, index) => {
                                return (
                                  <Grid
                                    size={{ xs: 12, sm: 6, md: 12, lg: 6, xl: 6 }}
                                    key={index}
                                    borderLeft={
                                      IsXS
                                        ? ""
                                        : IsSM
                                          ? (data.paragraph.length === 3 ? (index !== 0 && index !== data.paragraph.length - 1) : index !== 0)
                                            ? "1px solid #e0e0e0"
                                            : ""
                                          : index !== 0 && data.paragraph.length >= 2
                                            ? "1px solid #e0e0e0"
                                            : ""
                                    }
                                    pl={IsXS ? "" : 3}
                                  >
                                    <Grid container rowSpacing={3}>
                                      <Grid size={12}>
                                        <Grid container rowSpacing={1}>
                                          <Grid size={12} id={details.value}>
                                            <Typography
                                              className={styles.heroSectionHeading}
                                              color={data.color}
                                            >
                                              {details.title}
                                            </Typography>
                                          </Grid>
                                          <Grid size={12}>
                                            <Typography
                                              className={styles.heroHeading}
                                            >
                                              {details.heading}
                                            </Typography>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                      <Grid size={12}>
                                        <Grid container rowSpacing={1}>
                                          {details.description.map(
                                            (text, index) => {
                                              return (
                                                <Grid size={12} key={index}>
                                                  <Typography
                                                    className={styles.heroText}
                                                  >
                                                    <ArrowForwardIcon
                                                      sx={{
                                                        fontSize: "18px",
                                                        marginTop: "3px",
                                                        color: data.color,
                                                      }}
                                                    />
                                                    {text}
                                                  </Typography>
                                                </Grid>
                                              );
                                            }
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </motion.div>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default HeroSection;
